import { Money } from "./money.model";
export class CategoryInfo{
	categoryUUID: string;
	categoryName: string;
	price: Money;
	availableTickets: number;
	totalTickets: number
}



// WEBPACK FOOTER //
// ./src/app/models/category-info.model.ts